// extracted by mini-css-extract-plugin
module.exports = {"favorite-item":"FavoriteList_favorite-item__1wtY1","actions":"FavoriteList_actions__1zksH"};